import { render } from "./AboutUs.vue?vue&type=template&id=dbac0064"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=dbac0064&lang=scss"
script.render = render

export default script